import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { Loss } from '@typeRoots/common/loss';
import { RootState } from 'src/store/store';

interface LossState {
  losses: Loss[]; // All losses for a company
  selectedLoss: Loss | null; // Currently selected loss
  isDirty: boolean; // Tracks unsaved changes
}

const initialState: LossState = {
  losses: [],
  selectedLoss: null,
  isDirty: false,
};

const lossSlice = createSlice({
  name: 'loss',
  initialState,
  reducers: {
    setLosses: (state, action: PayloadAction<Loss[]>) => {
      state.losses = action.payload;
      state.isDirty = false; // Reset dirty flag
    },
    createLossSuccess: (state, action: PayloadAction<Loss>) => {
      state.losses.push(action.payload);
      state.isDirty = true; // Mark as dirty
    },
    updateLossSuccess: (state, action: PayloadAction<Loss>) => {
      const updatedLoss = action.payload;
      const index = state.losses.findIndex((loss) => loss.id === updatedLoss.id);
      if (index !== -1) {
        state.losses[index] = updatedLoss;
        state.isDirty = true; // Mark as dirty
      }
    },
    deleteLossSuccess: (state, action: PayloadAction<number>) => {
      const lossId = action.payload;
      state.losses = state.losses.filter((loss) => loss.id !== lossId);
      state.isDirty = true; // Mark as dirty
    },
    setSelectedLoss: (state, action: PayloadAction<Loss | null>) => {
      state.selectedLoss = action.payload;
    },
    resetLossState: () => initialState,
  },
});

export const {
  setLosses,
  createLossSuccess,
  updateLossSuccess,
  deleteLossSuccess,
  setSelectedLoss,
  resetLossState,
} = lossSlice.actions;

export const selectLosses = (state: RootState) => state.loss.losses;
export const selectSelectedLoss = (state: RootState) => state.loss.selectedLoss;

export default lossSlice.reducer;
